const exportToCSV = (data: string, filename:string) => {
    const link = document.createElement("a");
    link.download = filename;
    link.href = "data:text/csv;base64," + data;
    document.body.appendChild(link); // Needed for Firefox
    link.click();
    document.body.removeChild(link);
};

export default exportToCSV;